import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import { cancelSubscriptionByUserIdAndProgramId } from 'utils/queries'

export const useSubscription = (userId?: string, programId?: string) => {
  const queryClient = useQueryClient()

  const cancelSubscription = useMutation(
    async () => {
      if (!userId || !programId) throw new Error('Error canceling subscription!')
      await cancelSubscriptionByUserIdAndProgramId(userId as string, programId as string)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['userSubscriptions'])
      },
    },
  )

  return {
    cancelSubscription,
  }
}
